// extracted by css-extract-rspack-plugin
export default {"root":"root-J0DHj0","button":"button-QRnKul"};